export const errorMessages = {
    required: "This field is required.",
    validMobileNumber: "Please enter a valid mobile number",
    validEmail: "Please enter a valid email address",
    passwordMismatch: "Passwords do not match",
    strongerPassword: "Please choose a stronger password.",
    fieldsRequired: "Please fill the required fields.",
    tokenEmptyValidations: "Token should not be empty."
}